export const LOCAL_STORAGE_KEYS = {
    SIDEBAR_WIDTH: 'psv-sidebar-width',
    SHOW_QUICK_ACTIONS: 'psv-show-quick-actions',
    STUDY_GRID_COL_STATE: 'psv-study-grid-col-state',
    JOBS_GRID_COL_STATE: 'psv-jobs-grid-col-state',
};
export const REDIRECT_URL_STORAGE_KEY = {
    REDIRECT_URL: 'psv-redirect-url',
};
